export default {
    bindcard: '绑定银行卡',
    prephone: '更换预留手机号',
    banks: '支持银行',
    repay: '确认还款',
    repayRedPacket: '还款优惠券',
    status: '结果详情',
    // offlineRepay: '线下还款',
    offlineRepay: '银行转账还款',
    offlineRepayGuide: '银行转账还款',
    recordList: '还款记录',
    pay: '确认支付',
    payResult: '结果详情',
    loanBindCard: '额度申请',
    // creditCard: '信用卡还款',
    // creditCardRepayRecords: '还款记录',
    // creditCardRepayResult: '还款结果',
    // creditCardAdd: '添加信用卡',
    // creditCardRepay: '还款',
    // creditCardManage: '信用卡管理',
    repayInTime: '线下还款',
    offlineRepayMore: '线下还款',
    patchSigning: '银行卡鉴权',
    loanBindCardNew: '额度申请',
    'withdrawCard/bind': '绑定银行卡',
    'withdrawCard/bindResult': '绑卡结果'
}
